
import TrackingService from 'app/services/tracking/tracking.service';
import StatusConfigService from "external-services/status-config-service/index";
import TagsService from "external-services/tags-service";
import {BookingStatusNames} from "app/bookingStatusTypes";
import AdminService from "external-services/diary-admin-service";
import {cloneDeep} from "lodash-es";
import {bookingStatusType} from "shared-types/bookingStatusTypes";

const NS = 'StatusEditorCtrl';

const CLR_UNCONFIRMED = {name: 'Peach', value: '#FFE6A6'};
const CLR_CONFIRMED = {name: 'Light Green', value: '#CEFFE1'};
const CLR_STANDBY = {name: 'Light Blue', value: '#4669ac'};
const CLR_PARTIALLY_SEATED = {name: 'Dark Orange', value: '#f68b1f'};

export default function StatusEditorCtrl(
  $log, $scope, $mdDialog, status, highestOrder, statuses, colorInfo
) {
  "ngInject";

  const vm = this;
  //-- define public properties
  vm.title = 'New Status';
  vm.statusTypes = ['partially-seated', 'seated', 'unconfirmed'];
  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;
  vm.state = vm.ENTER;
  //-- define public methods
  vm.cancel = cancel;
  vm.save = save;
  vm.statuses = statuses;
  vm.BookingStatusNames = BookingStatusNames;
  vm.venue = AdminService.getVenue();
  vm.showStatusColor = vm.venue.enableNewFloorPlan; // show the new status color dropdown if floorplan is enabled
  vm.statusColors = TagsService.tagColours; // we are using the same colors in tag dropdown

  if (status) {
    TrackingService.trackPageView('settings.status.edit');
    vm.statusColors = cloneDeep(TagsService.tagColours); // we are using the same colors in tag dropdown
    vm.status = status;
    vm.edit = true;
    vm.title = 'Edit Status';
    // if the particular status is present add its default color
    switch (vm.status.statusType) {
      case bookingStatusType.unconfirmed: {
        vm.statusColors.push(CLR_UNCONFIRMED);
        break;
      }
      case bookingStatusType.confirmed: {
        vm.statusColors.push(CLR_CONFIRMED);
        break;
      }
      case bookingStatusType.standbyPending: {
        vm.statusColors.push(CLR_STANDBY);
        break;
      }
      case bookingStatusType.partiallySeated: {
        vm.statusColors.push(CLR_PARTIALLY_SEATED);
        break;
      }
    }


    vm.status.statusColor = vm.status.statusColor || colorInfo.background;

  } else {
    TrackingService.trackPageView('settings.status.new');
    var order = highestOrder + 1;
    vm.status = {
      enabled: true,
      editable: true,
      custom: true,
      order: order
    };
  }

  function cancel() {
    $mdDialog.hide();
  }

  function save(isValid) {
    if (isValid) {
      StatusConfigService.saveStatus(vm.status).then(function () {
        vm.state = vm.SUCCESS;
        $mdDialog.hide();
      }).catch(function () {
        vm.state = vm.ENTER;
      });

    } else {
      vm.displayErrors = true;
    }
  }

}
